/**
 * 校正HTML文本数据
 * 需求：富文本、后台返回、JSON转化的造成显示的字符段不能直接显示
 * 1、出现特殊符号需将特殊符号转换成可读取的内容（标签）
 * 2、需要清除多余的空格与换行，甚至无用标签
 * 3、需要对部分字符段进行更改
 * 方法：通过正则表达式(RegExp)验证，通过string.replace()进行替换
 * 正则表达式： 全部空格(/\s+/g)，两侧空格(/^\s+|\s+$/g)，左侧空格(/^\s/)，右侧空格(/(\s$)/g) 换行(/[\r\n]/g)，多余P标签(/<p>(\s|\&nbsp\;| |　|\xc2\xa0)*<\/p>/ig)，返斜杠(/\\/g) 
 * 获取所有图片(/<img.+?>/ig)，获取图片标签(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi)
 */
import base from "@/utils/base_url"
let baseUrl = ""
if (process.env.NODE_ENV === "development") {
	baseUrl = base.dev_url;
} else if (process.env.NODE_ENV === "production") {
	baseUrl = base.pro_url;
}

// 1、特殊符号转换成转义字符
function symbolEscape(val) {
	if (val != null && val != "") {
		const entities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"' };
		return val.replace(/[<>&"]/g, function (c) {
			return entities[c];
		});
	} else {
		return '';
	}
};

// 2、转义字符反换成特殊符号
function symbolReverseEscape(val) {
	if (val != null && val != "") {
		const entities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"' };
		return val.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
			return entities[t];
		});
	} else {
		return '';
	}
};

// 清理Html字符串数据
function clearHtmlString(val) {
	if (val != null && val != "") {
		let msg = val.replace(/\s+/g, " "); // 去除多余空格（中文空格、英文空格都会被替换）
		msg = msg.replace(/\\/ig, ""); // 去除su空格字符
		msg = msg.replace(/"""/ig, ""); // 去除su空格字符
		msg = msg.replace(/[\r\n]/g, ""); //去掉所有的换行符
		return msg.trim(); // 去除换行并删除前后空格
	} else {
		return '';
	}
};

// 4、清除所有Html标签
function clearHtmlTag(val, num=100) {
	if (val != null && val != "") {
		const reg = new RegExp("<.+?>|&.+?;","g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
		let msg = val.replace(reg, ""); // 去除多余空格（中文空格、英文空格都会被替换）
		msg = msg.replace(/\s+/g, ""); // 去除多余空格（中文空格、英文空格都会被替换）
		return msg.substr(0, num); // 默认获文本文字内容的前100个字符
	} else {
		return '';
	}
};

// 5、清除Html多余P标签
function clearHtmlPPTag(val) {
	if (val != null && val != "") {
		// var p_Html = str.match(/<p[^>]*>(?:(?!<\/p>)[\s\S])*<\/p>/gi); //匹配整个P标签的内容
		// var pp_Html = str.match(/<p(.*)<\/p>/g); //匹配P标签有内容，只有html标签的没有其他内容的不会匹配到
		// for (var i = 0; i < p_Html.length; i++) {
		// 	if (pp_Html.indexOf(p_Html[i]) < 0) {
		// 		str = str.replace(p_Html[i], "");
		// 	}
		// }
		const reg = new RegExp(/<p>(\s|\&nbsp\;| |　|\xc2\xa0)*<\/p>/,"g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
		let msg = val.replace(reg, ""); // 去除多余P标签
		return msg.trim(); // 去除换行并删除前后空格
	} else {
		return '';
	}
};

// 6、处理文本中的图片信息
function arrangeImages(val, type) {
	if (val != null && val != "") {
		let msg = val
		if (val.includes('<img')) {
			msg.replace(/<img.+?>/ig, function (match, capture) {
				// console.log("正则匹配所有图片并获取相应下标==>",match, captureImg);
				let src = ''; // 自定义变量接收图片
				match.replace(/<img[^>]*src=['"]([^'"]+)[^>]*>/gi, function (matchSrc, captureSrc) {
					// console.log("正则匹配该图片并获取相应路径==>",matchSrc, captureSrc);
					src = captureSrc.replace("../uploads", baseUrl + "uploads");
				});
				let data = ""
				switch (type) {
					case 1: // 小图片点击显示大图
						data = `<img src="${baseUrl}/static/images/file-icons/icon_image.png alt="图片" width="46px" height="46px" onClick="showBig(event,'${src}', 1)">`
						break;
					case 2: // 小图片点击显示大图
						data = `<img src="${src}" alt="图片" style="width: 46px; height: 46px; border-radius: 5px;; margin: 4px;" onClick="showBig(event,'${src}', 1)">`
						break;
					default: // 直接显示图片
						data = `<img src="${src}" style="max-width:80%; margin: 4px;"`
						break;
				}
				// 在图片中插入点击事件并默认不展示
				const newData = match.replace(/<s?img[^>]*src=['"]([^'"]+)[^>]*>/gi, data)
				msg = msg.replace(match, newData)
			});
		}
		return msg;
	} else {
		return '';
	}
}

// 7、处理文本中的图片信息
function arrangeVideos(val, type) {
	if (val != null && val != "") {
		let msg = val
		if (val.includes('<video')) {
			msg.replace(/(<video[\s\S]*?>)[\s\S]*?(<\/video>)/ig, function (match, capture) {
				// console.log("正则匹配所有图片并获取相应下标==>",match, capture);
				let src = ''; // 自定义变量接收图片
				match.replace(/<source [^>]*src=['"]([^'"]+)[^>]*>/gi, function (matchSrc, captureSrc) {
					// console.log("正则匹配该图片并获取相应路径==>",matchSrc, captureSrc);
					src = captureSrc.replace("../uploads", baseUrl + "uploads");
				});
				let data = ""
				switch (type) {
					case 1: // 小图片点击显示大图
						data = `<img src="${baseUrl}/static/images/file-icons/icon_video.png" alt="视频" width="46px" height="46px" onClick="showBig(event,'${src}', 2)">`
						break;
					default: // 直接显示图片
						data = `<br/><video controls="controls" width="500" height="300"><source src="${src}" type="video/mp4"/></video>`
						break;
				}
				// 在图片中插入点击事件并默认不展示
				const newData = match.replace(/<s?video[\s\S]*?>[\s\S]*?<\/video>/gi, data)
				msg = msg.replace(match, newData)
			});
		}
		return msg;
	} else {
		return '';
	}
}

export {
	symbolEscape,
	symbolReverseEscape,
	clearHtmlString,
	clearHtmlTag,
	clearHtmlPPTag,
	arrangeImages,
	arrangeVideos,
};
